import { render, staticRenderFns } from "./EditTweet.vue?vue&type=template&id=36b4a552&scoped=true"
import script from "./EditTweet.vue?vue&type=script&lang=js"
export * from "./EditTweet.vue?vue&type=script&lang=js"
import style0 from "./EditTweet.vue?vue&type=style&index=0&id=36b4a552&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b4a552",
  null
  
)

export default component.exports